import { meterType, nameTypeByType } from './Meters.constants'

export const c5Types = {
	default: {
		id: meterType.C5,
		name: nameTypeByType(meterType.C5)
	}
}
